import { createStyles, makeStyles } from 'ui-components';

export default makeStyles(() => createStyles({
  root: {
    width: '100%',
    minWidth: 0,

    '& .highcharts-container, & .highcharts-root': {
      width: '100% !important',
    },
  },
}), { name: 'RetirementCalculatorChart' });
